export default function TipsReducer(state = false, action) {
	switch (action.type) {
		case "SET_TIPS":
			return !state;
		default:
			return state;
	}
}
